export class GLItem {
  seq: number;
  glcode: number;
  itemSub:string;
  glasg: number;
  itemNo: number;
  itemDesc: string;
}
